import Hero from "@/components/home/Hero";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import CategoryGrid from "@/components/home/CategoryGrid";
import ManufacturerAndVehicles from "@/components/home/ManufacturerAndVehicles";
import { InfoSection, HowItWorks, Commercial, MarketplaceReputation, FitmentCTA, KnowledgeCards, FinalCTA } from "@/components/home/Sections";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <FeaturedProducts />
      <CategoryGrid />
      <ManufacturerAndVehicles />
      <InfoSection />
      <HowItWorks />
      <Commercial />
      <MarketplaceReputation />
      <FitmentCTA />
      <KnowledgeCards />
      <FinalCTA />
    </div>
  );
}
